import React, { useState } from "react";
import MemberForm from "./MemberForm";

function AddMemberButton() {
  // use to determine whether the task detail is reveal or hidden
  const [modalOpenMemberForm, setModalOpenMemberForm] = useState(false);

  // reveal the task detail
  const openModalMemberForm = () => {
    setModalOpenMemberForm(true);
  };

  // make the task detail hidden
  const closeModalMemberForm = () => {
    setModalOpenMemberForm(false);
  };

  return (
    <div>
      <button
        className="bg-[#404040] text-white px-[10px] py-[5px] rounded-xl flex "
        onClick={openModalMemberForm}
      >
        <div>Add member</div>
        <div className="mt-[0.5px]">
          <i class="fa-solid fa-plus ml-[7px]"></i>
        </div>
      </button>
      {modalOpenMemberForm === true && (
        <MemberForm onClose={closeModalMemberForm} />
      )}
    </div>
  );
};

export default AddMemberButton;
